import { saveRecentDashboard } from './recentDashboards';
import { formatAddress } from './formatAddress';

export function prepareProjectSelection(project, department) {
  const resolvedDepartment = department || project.dv_Division_New__c || 'Engineered Fill';

  localStorage.setItem('selectedDepartment', resolvedDepartment);
  localStorage.setItem('isProjectSelected', 'true');
  localStorage.setItem('selectedRowId', project.Id);

  window.dispatchEvent(new CustomEvent('departmentChanged', { detail: resolvedDepartment }));

  return resolvedDepartment;
}

export async function openProjectFromOpportunity({
  authFetch,
  navigate,
  opportunityId,
  projectRecord,
  department,
}) {
  let project = projectRecord;

  if (!project) {
    const allOpportunitiesResponse = await authFetch(
      `${process.env.REACT_APP_BACKEND_BASEURL}/api/salesforce/all-opportunities`
    );
    const allOpportunitiesData = await allOpportunitiesResponse.json();
    project = allOpportunitiesData.records?.find((record) => record.Id === opportunityId);
  }

  if (!project) {
    throw new Error('Project not found');
  }

  const resolvedDepartment = prepareProjectSelection(project, department);

  let projectInfoData = {
    bill_date: null,
    contract: null,
    tax_exempt: null,
    certified_payroll: null,
    p_and_p_bonds: null,
    ccip: null,
    retainage: null,
    prevailing_wage: null,
  };

  try {
    const projectInfoResponse = await authFetch(
      `${process.env.REACT_APP_BACKEND_BASEURL}/api/salesforce/projects/${project.Project__c}/Info`
    );
    if (projectInfoResponse.ok) {
      const projectInfo = await projectInfoResponse.json();
      const records = projectInfo.records || projectInfo;
      projectInfoData = {
        bill_date: records.bill_date || null,
        contract: records.contract || null,
        tax_exempt: records.tax_exempt || null,
        certified_payroll: records.certified_payroll || null,
        p_and_p_bonds: records.p_and_p_bonds || null,
        ccip: records.ccip || null,
        retainage: records.retainage || null,
        prevailing_wage: records.prevailing_wage || null,
      };
    }
  } catch (error) {
    console.error('Error fetching project info:', error);
  }

  const projectDetails = {
    id_project: project.Id,
    company: project.Company__c,
    projectNo: project.Project__r?.Project_System_Wide_ID__c,
    opportunityNo: project.Opportunity_System_Wide_ID__c,
    projectName: project.Project__r?.Name,
    customerName1: project.Contract_With__r?.Name,
    scope: project.dv_Type__c,
    deliveryMethod: project.Delivery_Method__c,
    scopeDescription: project.Project_Scope__c,
    projectStatus: project.Status || '-',
    billingDate: projectInfoData.bill_date || '-',
    contract: projectInfoData.contract || '-',
    street: project.Project__r?.Street__c || '',
    city: project.Project__r?.gmb_City__c || '',
    state: project.Project__r?.gmb_Project_State__c || '',
    zipCode: project.Project__r?.Zip_Code__c || '',
    Address: {
      Street: project.Project__r?.Street__c || '',
      City: project.Project__r?.gmb_City__c || '',
      State: project.Project__r?.gmb_Project_State__c || '',
      ZipCode: project.Project__r?.Zip_Code__c || '',
    },
    projectAddress: formatAddress({
      Street: project.Project__r?.Street__c || '',
      City: project.Project__r?.gmb_City__c || '',
      State: project.Project__r?.gmb_Project_State__c || '',
      ZipCode: project.Project__r?.Zip_Code__c || '',
    }),
    customerName: project.Contract_With__r?.Name || '-',
    customerStreet: project.Contract_With__r?.BillingStreet || '',
    customerCity: project.Contract_With__r?.BillingCity || '',
    customerState: project.Contract_With__r?.BillingState || '',
    customerZipCode: project.Contract_With__r?.BillingPostalCode || '',
    opportunityName: project.Name,
    opportunityUUID: project.Opportunity_System_Wide_ID__c,
    projectId: project.Project__r?.Project_System_Wide_ID__c,
    division: project.dv_Division_New__c,
    salesforceProjectId: project.Project__c,
    estimatingFolderLink: project.Project__r?.Nettles_Estimating_Folder_Link__c || null,
    sharepointItemId: project.Project__r?.Sharepoint_Item_ID_Project__c || null,
    taxExempt: projectInfoData.tax_exempt || '-',
    certifiedPayroll: projectInfoData.certified_payroll || '-',
    ppBonds: projectInfoData.p_and_p_bonds || '-',
    ccip: projectInfoData.ccip || '-',
    retainage: projectInfoData.retainage || '-',
    prevailingWage: projectInfoData.prevailing_wage || '-',
    bill_date: projectInfoData.bill_date || '-',
    tax_exempt: projectInfoData.tax_exempt || '-',
    certified_payroll: projectInfoData.certified_payroll || '-',
    p_and_p_bonds: projectInfoData.p_and_p_bonds || '-',
    prevailing_wage: projectInfoData.prevailing_wage || '-',
  };

  localStorage.setItem('selectedProjectDetails', JSON.stringify(projectDetails));
  localStorage.setItem('scrollToSelectedRow', 'true');

  saveRecentDashboard({
    projectId: projectDetails.projectId,
    projectName: projectDetails.projectName,
    customerName1: projectDetails.customerName1,
    opportunityNo: projectDetails.opportunityNo,
    id_project: projectDetails.id_project,
    Id: project.Id,
    department: projectDetails.division || resolvedDepartment,
    ...projectDetails,
  });

  window.dispatchEvent(new CustomEvent('projectDetailsChanged', { detail: projectDetails }));
  window.scrollTo(0, 0);
  navigate('/dashboard');

  return projectDetails;
}
